<template>
  <div>
    <ToolbarAuth />
    <Navigation />

    <div class="mt-15 ml-15 mr-15">
      <v-card>
        <v-card-title class="primary--text text-uppercase">
          {{ $t("crud.change") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <FlashMessage :error="error" v-if="error" key="error" />
          <v-text-field v-model.trim="dataext.colorA" outlined shaped label="Primaire kleur" />
          <v-text-field v-model.trim="dataext.colorB" outlined shaped label="Secundaire kleur" />
          <v-text-field v-model.trim="dataext.colorC" outlined shaped label="Positieve waarde familiestatuut" />
          <v-text-field v-model.trim="dataext.colorD" outlined shaped label="Negatieve waarde familiestatuut" />
          <v-text-field v-model.trim="dataext.colorE" outlined shaped label="Extra kleur" />
          <v-text-field v-model.trim="dataext.breedteA" outlined shaped label="Breedte logo" />
          <v-text-field v-model.trim="dataext.wwwadres" outlined shaped label="www adres PowerPoint" />
          <v-text-field v-model.trim="dataext.pptxnaam" outlined shaped label="naam onderschrift PPTX" />

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="text-end mr-15">
            <v-btn color="accent" @click="closeItem()" class="mr-8"
            >{{ $t("crud.close") }}
            </v-btn>
            <v-btn color="primary" @click="saveItem()"
            >{{ $t("crud.change") }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
import FlashMessage from "@/components/input/FlashMessage";
import { getError } from "@/utils/helpers";
import ColorService from "@/services/maintain/ColorService";
export default {
  name: "Users",
  components: {
    FlashMessage,
    ToolbarAuth,
    Navigation,
  },
  data() {
    return {
      error: null,
      dataext: {},
    };
  },
  methods: {
    getData() {
      let Id = 1;
      this.loading = true;
      ColorService.getMain(Id)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => (this.loading = false));
    },
    saveItem() {
      let Id = 1;
      const payload = {
        colorA: this.dataext.colorA,
        colorB: this.dataext.colorB,
        colorC: this.dataext.colorC,
        colorD: this.dataext.colorD,
        colorE: this.dataext.colorE,
        breedteA: this.dataext.breedteA,
        wwwadres: this.dataext.wwwadres,
        pptxnaam: this.dataext.pptxnaam,

      };
      this.error = null;
      ColorService.updateMain(Id, payload)
        .then(() => {
          this.$router.replace({
            name: "colorsIndex",
          });
        })
        .catch((error) => (this.error = getError(error)));
    },

    closeItem() {
      this.$router.replace({
        name: "colorsIndex",
      });
    },
  },
  computed: {},
  created() {
    this.getData();
  },
};
</script>

<style scoped></style>
